module.exports = __webpack_public_path__ + "teqbahn-assets/media/5.6235c1ed.jpg";